import { TableSkeleton, TicketTable, Typography } from '@components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TicketService } from '../../services/tickets/Tickets';
import { RootState } from '../../state/store';
import TicketForm from '../tickets/TicketForm';

interface props {
  assetId: number;
}

export const HardwareTickets = ({ assetId }: props) => {
  const [loading, setLoading] = useState(true);
  const [tickets, setTickets] = useState([]);
  const companyId = useSelector(
    (state: RootState) => state.companies.selectedCompany?.id
  );
  const service = new TicketService();

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      await fetchTickets();
      setLoading(false);
    };

    fetchData();
  }, [assetId]);

  const fetchTickets = async () => {
    const tickets = await service.getAssetTicketHistory(assetId);
    // const { tickets } = await service.getTickets(
    //   companyId,
    //   'HARDWARE',
    //   assetId
    // );
    setTickets(tickets.entries.ticket);
  };

  return (
    <div>
      <div className="mb-5">
        <TicketForm type="HARDWARE" type_value={assetId} />
      </div>

      {loading ? (
        <TableSkeleton />
      ) : (
        <>
          <Typography type="header" tag="h2">
            Tickets
          </Typography>
          <TicketTable tickets={tickets} />
        </>
      )}
    </div>
  );
};

export default HardwareTickets;
